<form #payment="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div id="payment-element" #paymentElement>
      <!-- A Stripe Element will be inserted here. -->
    </div>
    @if ((isPaying$ | async) === false && (immediateError || lastPaymentProcessingError)) {
      <div id="error-message" role="alert">
        <div class="error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" preserveAspectRatio="none">
            <path d="M13 14h-2V9h2m0 9h-2v-2h2M1 21h22L12 2 1 21z" fill="#f44336" />
          </svg>
        </div>
        <div class="error-title">{{ 'INVOICE.PAYMENT_FAILED' | translate }}</div>
        <div class="error-details">
          {{ immediateError ? immediateError : lastPaymentProcessingError }}
        </div>
      </div>
    }
  </div>
  <ng-container *ngIf="isPaying$ | async; else paymentButton">
    <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <path
        [ngStyle]="{ fill: primaryColor }"
        d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </ng-container>
  <ng-template #paymentButton>
    <button
      type="submit"
      [ngClass]="{ disabled: isPaymentButtonDisabled() }"
      [ngStyle]="{ 'border-color': primaryColor, background: primaryColor }"
      [disabled]="isPaymentButtonDisabled()"
    >
      {{ 'PAYMENT_FORM.PAY_INVOICE' | translate }}
    </button>
  </ng-template>
</form>
